import { defineComponent, onMounted, ref, watch, onBeforeUnmount, reactive } from 'vue'
import '@/common/echart/map/fujian.js'
import theme from '@/common/echart/style/theme.js' // 引入默认主题
import * as echarts from 'echarts'
const E = (window as any).echarts || echarts

const ensureMap = async (name: string) => {
  if (E.getMap(name)) return
  const codeMap: Record<string, string> = {
    '福建': '350000'
  }
  const code = codeMap[name]
  if (!code) return
  try {
    const res = await fetch(`https://geo.datav.aliyun.com/areas_v3/bound/${code}_full.json`)
    if (!res.ok) return
    const geojson = await res.json()
    E.registerMap(name, geojson)
  } catch {}
}

// 定义类型
const PropsType = {
  // 图表唯一 id
  id: String,
  // 图表类名
  className: {
    type: String,
    default: 'chart'
  },
  // 图表宽度
  width: {
    type: String,
    require: true
  },
  // 图表高度
  height: {
    type: String,
    require: true
  },
  // 图表数据项
  options: {
    type: Object,
    default: () => ({}),
  }
} as const

export default defineComponent({
  name: 'Echarts',
  props: PropsType,
  setup(props, { expose }) {
    const chartRef = ref<HTMLElement>()
    const charts = {
      chart: null
    }
    
    /**
     * 初始化echart
     * @param data 数据项
     * @param clearCaching 是否清除缓存
     */
    const initChart = (data?: any, clearCaching = false) => {
      const opt = data || props.options
      if (!opt) return
      const hasGeo = !!(opt as any).geo && (
        !!(opt as any).geo.map ||
        (Array.isArray((opt as any).geo) && (opt as any).geo.some((g: any) => !!g.map))
      )
      const hasMapSeries = Array.isArray((opt as any).series) && (opt as any).series.some((s: any) => s.type === 'map' || !!s.map || !!s.mapType)
      if (hasGeo || hasMapSeries) {
        ensureMap('福建').then(() => {
          charts.chart && charts.chart.setOption(opt, clearCaching)
        })
      } else {
        charts.chart && charts.chart.setOption(opt, clearCaching)
      }
    }

    // 生命周期
    onMounted(() => {
      E.registerTheme('myTheme', theme)
      charts.chart = E.init(chartRef.value, 'myTheme')
      initChart()
    })
    onBeforeUnmount(() => {
      charts.chart.dispose()
      charts.chart = null
    })

    // 监听改变
    watch(
      () => props.options,
      val => {
        val && initChart(val)
      },
      {
        deep: true
      }
    )

    // 对外暴露接口
    expose({
      chartRef,
      initChart
    });

    return () => {
      const { id, className, height, width } = props
      return <div
        ref={chartRef}
        id={id as string}
        class={className as string}
        style={{
          'height': height as string,
          'width': width as string
        }}
      />
    }
  }
})